module.exports = __webpack_public_path__ + "img/grate-droplet.21a2a8f2.svg";